import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SCSS_COLORS } from '../../../../colors';
import { BlueCircleButtonConfig } from '../../../components/circle-button/circle-button.props';

@Component({
  selector: 'lp2-industry-add-topic',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [ngClass]="centered ? 'centered' : 'start'">
      <lp2-circle-button
        icon="fa-plus"
        [colors]="blueCircleButtonConfig"
        (click)="onAddIndustryClick()"
      ></lp2-circle-button>
      <span class="ml-3 cursor-pointer" id="title" [style.color]="colors['$oe-blue']" (click)="onAddIndustryClick()">
        {{ title }}
      </span>
    </div>
  `,
  styles: [
    `
      .start {
        padding-left: 24px;
      }
      .centered {
        display: flex;
        justify-content: center;
        align-items: baseline;
      }
      .cursor-pointer {
        cursor: pointer;
      }
    `,
  ],
})
export class IndustryAddTopicComponent {
  @Input() title: string;
  @Input() centered = false;
  @Output() addIndustryClick = new EventEmitter();
  colors = SCSS_COLORS;
  blueCircleButtonConfig = BlueCircleButtonConfig;

  onAddIndustryClick() {
    this.addIndustryClick.emit();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/industry-content-section/industry-add-topic/industry-add-topic.component.ts